import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { GetHandleProps } from "react-compound-slider";

// *******************************************************
// HANDLE COMPONENT
// *******************************************************

type Props = {
  domain: [number, number];
  handle: { id: string; value: number; percent: number };
  disabled: boolean;
  getHandleProps: GetHandleProps;
};

export function ImageLevellingSliderHandle({
  domain: [min, max],
  handle: { id, value, percent },
  disabled,
  getHandleProps,
}:Props) {
  return (
    <Fragment>
      <div
        style={{
          left: `${percent}%`,
          position: "absolute",
          transform: "translate(-50%, -50%)",
          WebkitTapHighlightColor: "rgba(0,0,0,0)",
          zIndex: 5,
          width: 28,
          height: 42,
          cursor: "pointer",
          // border: '1px solid white',
          backgroundColor: "none",
        }}
        {...getHandleProps(id)}
      />
      <svg
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        style={{
          left: `${percent}%`,
          position: "absolute",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
          width: 25,
          height: 25,
        }}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12.5" cy="12.5" r="12" fill="white" stroke="#C4C4C4" />
        <rect
          x="10.7143"
          y="8.3335"
          width="1.19048"
          height="8.33333"
          fill="#C4C4C4"
        />
        <rect
          x="13.0952"
          y="8.3335"
          width="1.19048"
          height="8.33333"
          fill="#C4C4C4"
        />
      </svg>
      {/* </div> */}
    </Fragment>
  );
}

ImageLevellingSliderHandle.propTypes = {
  domain: PropTypes.array.isRequired,
  handle: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired,
  }).isRequired,
  getHandleProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ImageLevellingSliderHandle.defaultProps = {
  disabled: false,
};
